<template>
  <div :class="computedClass" />
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'full',
      validator: value => ['full', 'small'].includes(value),
    },
  },
  computed: {
    computedClass() {
      return `spacer-${this.type}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/metrics';

.spacer-full {
  flex: 1;
}

.spacer-small {
  width: $base;
}
</style>
